import React from "react";
import { UserSelect } from "_c/Select";
import { AbstractControlledField } from "_c/form/Field";

const DiscountClientSelect = (props) => {
  return (
    <AbstractControlledField
      sectStyle={{
        position: "relative",
        zIndex: 6,
      }}
      t={props.t}
      Component={UserSelect}
      noOptionsMessage={() => props.t("common:empty")}
      placeholder=""
      options={props.options}
      name="client"
      label={props.t(`${props.ns}.labels.choose_client`)}
      id={`${props.formId}-client`}
    />
  );
};

export default DiscountClientSelect;
